import React from 'react';
import { useTranslation } from 'react-i18next';
import { getCardApiValue, formatValue } from '../helpers';
import { checkKpiType } from '@flexo/general';
import parse from 'html-react-parser';


interface InformationCardContentLabelValueListProps {
  description: any[];
  overviewKpiApiData: any[];
  kpiContext: string;
  currencyFields: string[];
  id: string;
}

const InformationCardContentLabelValueList: React.FC<InformationCardContentLabelValueListProps> = ({ description, overviewKpiApiData, kpiContext, currencyFields, id }) => {
  const { t } = useTranslation();
  return (
    <span className="paragraph">
      {description.map((el, i, array) => {

        if (Array.isArray(el?.value)) {

          const value_1 = el?.value[0];
          const valueObj_1 = getCardApiValue(value_1, overviewKpiApiData, currencyFields);

          const value_2 = el?.value[1];
          const valueObj_2 = getCardApiValue(value_2, overviewKpiApiData, currencyFields);
          
          return (
            <React.Fragment key={`${id}-label-value-list-${i}`}>
              {parse(t(el.key, { value: valueObj_1.value, unit: valueObj_1.unit, percentage: valueObj_2.value }))}
              {i < array.length - 1 ? <br /> : ''}
            </React.Fragment>
          )
        } else {
          const valueObj = getCardApiValue(el?.value, overviewKpiApiData, currencyFields);
          return (
            <React.Fragment key={`${id}-label-value-list-${i}`}>
              <strong>{t(el.key)}{': '}</strong>
              {formatValue(valueObj.value, kpiContext, checkKpiType) + (valueObj?.unit || '')}
              {i < array.length - 1 ? <br /> : ''}
            </React.Fragment>
          );
        }
        
        
      })}
    </span>
  );
};

export default InformationCardContentLabelValueList; 